import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"

const firebaseConfig = {
  apiKey: "AIzaSyCXXnEE6qSnaKLtBzJTuwJi4_IkT_EyldM",
  authDomain: "frisco-order.firebaseapp.com",
  projectId: "frisco-order",
  storageBucket: "frisco-order.firebasestorage.app",
  messagingSenderId: "415761181496",
  appId: "1:415761181496:web:3f8e836edda385b5fd6fcd",
  measurementId: "G-BYQ49JFGLN",
  databaseURL: "https://frisco-order-default-rtdb.europe-west1.firebasedatabase.app/",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const realtimeDb = getDatabase(app);
